import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "position-relative" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "col-md-6 col-lg-4" }
const _hoisted_5 = { class: "alert alert-light" }
const _hoisted_6 = {
  key: 1,
  class: "row align-items-center"
}
const _hoisted_7 = { class: "col-sm-7" }
const _hoisted_8 = {
  key: 0,
  class: "form-label"
}
const _hoisted_9 = { class: "custom-file" }
const _hoisted_10 = {
  class: "form-label",
  for: "validatedCustomFile"
}
const _hoisted_11 = { class: "col-sm-5" }
const _hoisted_12 = { class: "d-grid" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 2,
  class: "row border-bottom border-light align-items-center py-2"
}
const _hoisted_15 = { class: "col-sm-7" }
const _hoisted_16 = { class: "col-sm-5 text-sm-end" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-eye",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Visa ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Radera ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { key: 3 }
const _hoisted_24 = {
  key: 0,
  class: "row border-bottom border-light align-items-center py-2"
}
const _hoisted_25 = { class: "col-sm-7" }
const _hoisted_26 = { class: "col-sm-5 text-sm-end" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-eye",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" })
], -1)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Visa ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-trash",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
  })
], -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Radera ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.status), 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.item.name) + " ", 1),
        _createElementVNode("em", null, _toDisplayString(_ctx.applicantName), 1),
        _createVNode(_component_Tooltip, {
          title: _ctx.item.description
        }, null, 8, ["title"])
      ])
    ]),
    (_ctx.item.note || _ctx.item.comment)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("small", null, _toDisplayString(_ctx.item.note ?? _ctx.item.comment), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showUploads)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.item.personalNumber)
              ? (_openBlock(), _createElementBlock("label", _hoisted_8, _toDisplayString(_ctx.checkPersonalNumber), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "file",
                class: "form-control",
                id: "validatedCustomFile",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
              }, null, 32),
              (_ctx.showProgress)
                ? (_openBlock(), _createBlock(_component_ProgressBar, {
                    key: 0,
                    backgroundColor: '#E0FFF0',
                    trackColor: '#50F8A0',
                    progressWidth: _ctx.progressWidth
                  }, null, 8, ["progressWidth"]))
                : _createCommentVNode("", true),
              _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.file.name), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                disabled: _ctx.file == null,
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[1] || (_cache[1] = () => _ctx.sendFile())
              }, " Ladda upp dokument ", 8, _hoisted_13)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.item.contentType && _ctx.item.customerUploads.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.item.title), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", {
              class: "btn btn-xs btn-link my-1",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDocument(_ctx.item.id)))
            }, _hoisted_19),
            _createElementVNode("span", {
              class: "btn btn-xs btn-link link-danger ms-1 my-1",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.deleteDocument(_ctx.item.id)))
            }, _hoisted_22)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showUploads)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.customerUploads, (content) => {
            return (_openBlock(), _createElementBlock("div", { key: content }, [
              (content.contentType)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("strong", null, _toDisplayString(content.title), 1)
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", {
                        class: "btn btn-xs btn-link my-1",
                        onClick: ($event: any) => (
              _ctx.openOfferDocumentContent(content.offerDocumentId, content.id)
            )
                      }, _hoisted_30, 8, _hoisted_27),
                      _createElementVNode("span", {
                        class: "btn btn-xs btn-link link-danger my-1 ms-1",
                        onClick: ($event: any) => (
              _ctx.deleteOfferDocumentContent(content.offerDocumentId, content.id)
            )
                      }, _hoisted_34, 8, _hoisted_31)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}